import { captureException } from '@sentry/nextjs';

import { CmsServiceBase } from '@app/services/abstracts/cms-service.base';

export class CmsAccommodationService extends CmsServiceBase {
    private static _instance: CmsAccommodationService;

    public static get instance(): CmsAccommodationService {
        if (!this._instance) {
            this._instance = new CmsAccommodationService();
        }

        return this._instance;
    }

    async getDescription(accommodationId: string): Promise<string | null> {
        try {
            const response = await this.axiosInstance.get<{ description: string }>(
                `/accommodation/${accommodationId}/description`,
                {
                    headers: { Accept: 'application/json' },
                },
            );
            return response.data?.description || null;
        } catch (error) {
            captureException(error);
            return null;
        }
    }
}
